import React from "react";

export const Services = (props) => {
  return (
    <div id="services">
      <div className="container">
        <div className="section-header">
          <div className="eyebrow">Solutions</div>
          <h2>Network Infrastructure Solutions</h2>
          <p className="section-sub">
            End-to-end systems engineered for performance, reliability, and growth.
          </p>
        </div>
        <div className="solutions-grid">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="solution-card">
                  <div className="solution-number">{d.number}</div>
                  <h3 className="solution-title">{d.name}</h3>
                  <p className="solution-text">{d.text}</p>
                  <a href={d.link} className="solution-link page-scroll">
                    Learn more &rarr;
                  </a>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
